import { Flex, MDIIcon } from '@solinkcorp/solink-components';
import Inbox from '@solinkcorp/solink-components/svg/inbox.svg?react';
import isString from 'lodash/isString';
import { NOTIFICATION_UNREAD_COUNT_DISPLAY_LIMIT } from 'vd-constants';

const NotificationInbox = ({ notificationCount, style = {}, onShowAll, slim }) => {
  let count = notificationCount;
  if (slim && count > NOTIFICATION_UNREAD_COUNT_DISPLAY_LIMIT) {
    count = `${NOTIFICATION_UNREAD_COUNT_DISPLAY_LIMIT}+`;
  }

  return (
    <Flex
      className="navbar-notification-status"
      style={style}
      onClick={onShowAll}
      data-testid="desk-nav-inbox"
    >
      <MDIIcon className="notification-inbox" icon={Inbox} size={20} />
      {(isString(count) || count > 0) && (
        <Flex alignItems="center" className="notification-badge" justifyContent="center">
          {count}
        </Flex>
      )}
    </Flex>
  );
};

export default NotificationInbox;
